// import React, { useState } from "react";
// import {
//     Grid,
//     TextField,
//     Button,
//     Typography,
//     Modal,
//     Box,
//     IconButton,
// } from "@mui/material";
// import { Formik, Form, Field, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import { Close } from "@mui/icons-material";
// import endpoints from "../../../endpoint";
// import axios from "axios";

// const validationSchema = Yup.object({
//     title: Yup.string().required("Title is required"),
//     description: Yup.string()
//         .min(20, "Description must be at least 20 characters")
//         .required("Description is required"),
//     image: Yup.mixed().required("Image is required"),
// });

// const CreateAnalyst = ({ open, onClose }) => {
//     const [isSubmitting, setIsSubmitting] = useState(false);

//     const handleSubmit = async (values) => {
//         console.log(values)
//         const token = sessionStorage.getItem('token')
//         try {

//             // step1 generate the presignurl to upload the image 
//             const imageUploadResponse = await axios.post(
//                 `${endpoints.serverBaseUrl}api/generate-presigned-url`,
//                 {
//                     fileName: values?.image?.name,
//                     fileType: values?.image.type,
//                 },
//                 { withCredentials: true, headers: { Authorization: `Bearer ${token}` } }
//             );

//             if (!imageUploadResponse.data.presignedUrl) {
//                 throw new Error("Failed to get presigned URL for image upload.");
//             }

//             const { presignedUrl: imagePresignedUrl, publicId: imageId } =
//                 imageUploadResponse.data;

//             await axios.put(imagePresignedUrl, values.image, {
//                 headers: { "Content-Type": values?.image.type },
//             });

//             const strategyPayload = {
//                 title: values.title,
//                 description: values.description,
//                 imageId,

//             };

//             // **4. Send Strategy Data to Backend**
//             try {
//                 const response = await axios.post(
//                     `${endpoints.serverBaseUrl}api/market`,
//                     strategyPayload,
//                     { headers: { Authorization: `Bearer ${token}` } }
//                 );
//                 if (response.data.success) {

//                     onClose();
//                 }

//             }
//             catch (error) {

//                 console.log(error)
//             }
//         } catch (error) {

//         }
//     }

//     return (
//         <Modal open={open} onClose={onClose}>
//             <Box
//                 sx={{
//                     position: "absolute",
//                     top: "50%",
//                     left: "50%",
//                     transform: "translate(-50%, -50%)",
//                     bgcolor: "background.paper",
//                     boxShadow: 24,
//                     p: 2,
//                     borderRadius: 2,
//                     width: "90%",
//                     maxWidth: 500,
//                 }}
//             >
//                 <IconButton
//                     sx={{ position: "absolute", top: 8, right: 8 }}
//                     onClick={onClose}
//                 >
//                     <Close />
//                 </IconButton>
//                 <Typography variant="h5" gutterBottom sx={{ textAlign: "center" }}>
//                     Create Analyst
//                 </Typography>
//                 <Formik
//                     initialValues={{
//                         title: "",
//                         description: "",
//                         image: null,
//                     }}
//                     validationSchema={validationSchema}
//                     onSubmit={handleSubmit}
//                 >
//                     {({ isValid, dirty, setFieldValue, values }) => (
//                         <Form>
//                             <Grid container spacing={2} p={2}>
//                                 <Grid item xs={12}>
//                                     <Field
//                                         as={TextField}
//                                         fullWidth
//                                         label="Title"
//                                         name="title"
//                                         required
//                                     />
//                                     <ErrorMessage name="title" component="div" style={{ color: "red" }} />
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <Field
//                                         as={TextField}
//                                         fullWidth
//                                         label="Description"
//                                         name="description"
//                                         required
//                                         multiline
//                                         rows={4}
//                                     />
//                                     <ErrorMessage name="description" component="div" style={{ color: "red" }} />
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <input
//                                         accept="image/*"
//                                         type="file"
//                                         id="image-upload"
//                                         style={{ display: "none" }}
//                                         onChange={(event) => {
//                                             setFieldValue("image", event.currentTarget.files[0]);
//                                         }}
//                                     />
//                                     <label htmlFor="image-upload">
//                                         <Button variant="contained" component="span">
//                                             Upload Image
//                                         </Button>
//                                     </label>
//                                     {values.image && (
//                                         <Typography mt={1}>{values.image.name}</Typography>
//                                     )}
//                                     <ErrorMessage name="image" component="div" style={{ color: "red" }} />
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <Button
//                                         fullWidth
//                                         variant="contained"
//                                         color="primary"
//                                         type="submit"
//                                         disabled={isSubmitting}
//                                     >
//                                         {isSubmitting ? "Creating..." : "Publish Analyst"}
//                                     </Button>
//                                 </Grid>
//                             </Grid>
//                         </Form>
//                     )}
//                 </Formik>
//             </Box>
//         </Modal>
//     );
// };

// export default CreateAnalyst;
import React, { useState } from "react";
import {
    Grid,
    TextField,
    Button,
    Typography,
    Modal,
    Box,
    IconButton,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
} from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Close } from "@mui/icons-material";
import endpoints from "../../../endpoint";
import axios from "axios";
import { CircularProgress } from "@mui/material"; // At the top
import { toast } from "react-toastify";


const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    description: Yup.string()
        .min(20, "Description must be at least 20 characters")
        .required("Description is required"),
    image: Yup.mixed().required("Image is required"),
    category: Yup.string().required("Category is required"),
});

const categories = ["Index-Analyst", "Stock-Analyst", "Swing-Trades"];

const CreateAnalyst = ({ open, onClose }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (values) => {
        console.log(values);
        const token = sessionStorage.getItem("token");
        try {
            // Step 1: Generate the presigned URL for image upload
            setIsSubmitting(true); // Set loading state
            const imageUploadResponse = await axios.post(
                `${endpoints.serverBaseUrl}api/generate-presigned-url`,
                {
                    fileName: values?.image?.name,
                    fileType: values?.image.type,
                },
                { withCredentials: true, headers: { Authorization: `Bearer ${token}` } }
            );

            if (!imageUploadResponse.data.presignedUrl) {
                throw new Error("Failed to get presigned URL for image upload.");
            }

            const { presignedUrl: imagePresignedUrl, publicId: imageId } = imageUploadResponse.data;

            await axios.put(imagePresignedUrl, values.image, {
                headers: { "Content-Type": values?.image.type },
            });

            // Step 2: Send Strategy Data to Backend
            const strategyPayload = {
                title: values.title,
                description: values.description,
                category: values.category,  // <-- Added Category
                imageId,
            };

            const response = await axios.post(
                `${endpoints.serverBaseUrl}api/market`,
                strategyPayload,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data.success) {
                onClose();
                toast.success("created successfully!");
                setIsSubmitting(false); // Reset loading state
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 2,
                    borderRadius: 2,
                    width: "90%",
                    maxWidth: 500,
                }}
            >
                <IconButton sx={{ position: "absolute", top: 8, right: 8 }} onClick={onClose}>
                    <Close />
                </IconButton>
                <Typography variant="h5" gutterBottom sx={{ textAlign: "center" }}>
                    Create Analyst
                </Typography>
                <Formik
                    initialValues={{
                        title: "",
                        description: "",
                        category: categories[0],  // Default category
                        image: null,
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isValid, dirty, setFieldValue, values }) => (
                        <Form>
                            <Grid container spacing={2} p={2}>
                                <Grid item xs={12}>
                                    <Field as={TextField} fullWidth label="Title" name="title" required />
                                    <ErrorMessage name="title" component="div" style={{ color: "red" }} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        fullWidth
                                        label="Description"
                                        name="description"
                                        required
                                        multiline
                                        rows={4}
                                    />
                                    <ErrorMessage name="description" component="div" style={{ color: "red" }} />
                                </Grid>

                                {/* Category Dropdown */}
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <InputLabel>Category</InputLabel>
                                        <Field
                                            as={Select}
                                            name="category"
                                            fullWidth
                                            label="Category"
                                        >
                                            {categories.map((category) => (
                                                <MenuItem key={category} value={category}>
                                                    {category}
                                                </MenuItem>
                                            ))}
                                        </Field>
                                    </FormControl>
                                    <ErrorMessage name="category" component="div" style={{ color: "red" }} />
                                </Grid>

                                <Grid item xs={12}>
                                    <input
                                        accept="image/*"
                                        type="file"
                                        id="image-upload"
                                        style={{ display: "none" }}
                                        onChange={(event) => {
                                            setFieldValue("image", event.currentTarget.files[0]);
                                        }}
                                    />
                                    <label htmlFor="image-upload">
                                        <Button variant="contained" component="span" sx={{ textTransform: "capitalize" }}>
                                            Upload Image
                                        </Button>
                                    </label>
                                    {values.image && <Typography mt={1}>{values.image.name}</Typography>}
                                    <ErrorMessage name="image" component="div" style={{ color: "red" }} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        sx={{ textTransform: "capitalize" }}
                                        type="submit"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? "Creating..." : "Publish Analyst"}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box>
        </Modal>
    );
};

export default CreateAnalyst;
